import { useCallback, useEffect, useState } from 'react';
import {
  hasSeenLauncherLabel,
  markLauncherLabelSeen,
  type LauncherLabelUserId,
} from '../utils/launcherLabelStorage';

export const useLauncherLabel = (userId: LauncherLabelUserId) => {
  const [seen, setSeen] = useState(() => hasSeenLauncherLabel(userId));

  useEffect(() => {
    setSeen(hasSeenLauncherLabel(userId));
  }, [userId]);

  const markSeen = useCallback(() => {
    markLauncherLabelSeen(userId);
    setSeen(true);
  }, [userId]);

  return { showLabel: !seen, markSeen };
};
